import React from 'react'
import PageWrapper from 'components/PageWrapper'

export const wrapPageElement = ({ element }) => (
  <PageWrapper>{element}</PageWrapper>
)
